import React from "react";

export default function FooterText() {
  return <>Copyright © {window.YEAR} Glory League Stats. </>;
}
